module.exports = __webpack_public_path__ + "img/investment-plan-image-mobile.b0c68aa1.png";